import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/fr/termsOfService')({
  component: () => TermsOfService({ pdfPath: '/TOS_SG_FR.pdf' }),
});